import Button from 'components/ui/button';
import { useAuth } from 'context/AuthContext';
import { useEffect, useState } from 'react';
import { IoIosClose } from 'react-icons/io';

import './styles.scss';
import FeedbackMandou from 'assets/img/comportamento/mandou.png';
import { getUserNotifications } from 'services/notifications.service';

export default function Notification() {
  const [notification, setNotification] = useState<any>();
  const [allNotification, setAllNotification] = useState<any>([]);

  const { user } = useAuth();

  async function handleClose() {
    if (allNotification?.length > 1) {
      const data = [...allNotification];
      setNotification(data[1]);
      const newData = data.slice(1);
      setAllNotification(newData);
    } else {
      setNotification(null);
      setAllNotification([]);
    }
  }

  async function loadData() {
    if (user) {
      const notifications = await getUserNotifications();
      if (notifications?.[0]) {
        setNotification(notifications[0]);
        setAllNotification(notification);
      }
    }
  }

  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  if (!notification) return null;

  return (
    <div className="modal-news fixed bg-black bg-opacity-40 top-0 left-0 w-screen h-screen p-6 pt-[10vh] flex justify-center overflow-y-auto">
      <div className="relative border-2 border-solid border-electric-blue bg-oxford-blue rounded-2xl p-10 max-w-[500px] h-fit">
        <Button
          color="primary"
          className="absolute -right-5 -top-5  rounded-r-full rounded-l-full w-10 h-10 p-0 flex justify-center items-center"
          onClick={() => handleClose()}
        >
          <IoIosClose color="white" size={30} />
        </Button>

        <div className='className="flex flex-col items-center justify-center text-center'>
          <div className="flex items-center justify-center mb-6">
            <img src={FeedbackMandou} alt="Imagem de feedback" className="w-[173px] block" />
          </div>
          {notification?.definition?.content !== 'rede' ? (
            <h1 className="block text-2xl font-semibold text-yellow mb-4 text-center">
              uhul! {notification?.item?.name} concluído
            </h1>
          ) : (
            <h1 className="block text-2xl font-semibold text-yellow mb-4 text-center">uhul! Você concluiu a ação:</h1>
          )}

          {notification?.definition?.content !== 'rede' ? (
            <p className="text-center">{notification?.definition?.content}</p>
          ) : (
            <p className="text-center">{notification?.item?.name}</p>
          )}
        </div>
      </div>
    </div>
  );
}
